export default __webpack_public_path__ + "9298e6e5d616fffd9b82c05f0bb0474f.jpg";